import { Form, Modal, message } from "antd";
import { useState } from "react";
import { CheckOutlined } from "@ant-design/icons";
import { handleUpdateLead } from "../../../../api/leads";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { capitalize } from "lodash";
export default function StatusModal({
  lead,
  lead_id,
  isVisible,
  setVisible,
}: any) {
  const [selected, setSelected] = useState(lead?.status);
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: handleUpdateLead,
    onSuccess: () => {
      message.success("Updated Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["leads", lead_id] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async (status: any) => {
    const data = {
      status: status.toLowerCase(),
    };
    await mutate({ data, _id: lead_id });
    setVisible(false);
  };

  const status = [
    { id: 1, name: "active" },
    { id: 2, name: "unresponsive" },
    { id: 3, name: "pending" },
    { id: 4, name: "approved" },
    { id: 5, name: "awaiting payment" },
    { id: 6, name: "won" },
    { id: 7, name: "lost" },
  ];

  return (
    <Modal
      open={isVisible}
      title={"Update Lead Status"}
      onCancel={() => setVisible(false)}
      footer={[]}
    >
      {status?.map((item: any, index: number) => (
        <button
          onClick={() => {
            setSelected(item?.name);
            onSubmit(item?.name);
          }}
          key={index}
          className={`p-2 bg-gray-100 mb-2 flex items-center w-full hover:bg-gray-50 focus:outline-none ${
            item?.name === lead?.status?.state ? "bg-green-100" : ""
          }`}
        >
          {item?.name === lead?.status?.state ? (
            <div className="border border-green-600 w-6 h-6 flex justify-center items-center bg-green-100">
              <CheckOutlined />
            </div>
          ) : (
            <div className="border w-6 h-6 flex justify-center items-center"></div>
          )}
          <div className="ml-2">{capitalize(item?.name)}</div>
        </button>
      ))}
    </Modal>
  );
}
